import isRawDateValid from './isRawDateValid'

/**
 * Check if a date string is incomplete from BasicDateStringPicker
 * Handles undefined, empty strings, and partial date selections (0-based placeholders)
 */
export function isDateEmpty(date?: string): boolean {
  if (!date?.trim()) return true
  return date.startsWith('0-') || date.includes('-0-') || date.endsWith('-0')
}

/**
 * Validate a date string format (YYYY-MM-DD)
 */
export function validateDateFormat(date: string): boolean {
  return isRawDateValid(date)
}

/**
 * Check if date1 is before date2
 */
export function isDateBefore(date1: string, date2: string): boolean {
  return new Date(date1) < new Date(date2)
}

/**
 * Check if date1 is before or equal to date2
 */
export function isDateBeforeOrEqual(date1: string, date2: string): boolean {
  return new Date(date1) <= new Date(date2)
}
